class LioraLensGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.liInitialized === 'true') return;
    this.dataset.liInitialized = 'true';

    this.modal = this.querySelector('[data-gallery-modal]');
    this.modalVideo = this.querySelector('[data-gallery-modal-video]');
    this.modalSource = this.querySelector('[data-gallery-modal-source]');
    this.modalTitle = this.querySelector('[data-gallery-modal-title]');
    this.modalPrice = this.querySelector('[data-gallery-modal-price]');
    this.modalLink = this.querySelector('[data-gallery-modal-link]');
    this.lastTrigger = null;

    this.openButtons = Array.from(this.querySelectorAll('[data-gallery-open]'));
    this.closeButtons = Array.from(this.querySelectorAll('[data-gallery-close]'));
    this.openHandlers = new Map();
    this.closeHandler = () => this.close();
    this.keydownHandler = (event) => {
      if (event.key === 'Escape' && !this.modal?.hidden) this.close();
    };

    this.openButtons.forEach((button) => {
      const handler = () => this.open(button);
      this.openHandlers.set(button, handler);
      button.addEventListener('click', handler);
    });
    this.closeButtons.forEach((button) => button.addEventListener('click', this.closeHandler));
    document.addEventListener('keydown', this.keydownHandler);
  }

  disconnectedCallback() {
    this.openHandlers?.forEach((handler, button) => button.removeEventListener('click', handler));
    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.closeHandler));
    document.removeEventListener('keydown', this.keydownHandler);
    if (this.modal && !this.modal.hidden) document.body.style.overflow = '';
    this.dataset.liInitialized = 'false';
  }

  open(button) {
    if (!this.modal || !this.modalVideo || !this.modalSource) return;

    const source = button.dataset.videoSrc || '';
    if (!source) return;

    this.lastTrigger = button;
    this.modalSource.src = source;
    this.modalSource.type = button.dataset.videoType || 'video/mp4';
    this.modalVideo.poster = button.dataset.poster || '';
    this.modalVideo.load();

    if (this.modalTitle) this.modalTitle.textContent = button.dataset.productTitle || button.dataset.videoTitle || '';
    if (this.modalPrice) this.modalPrice.textContent = button.dataset.productPrice || '';
    if (this.modalLink) {
      this.modalLink.href = button.dataset.productUrl || '#';
      this.modalLink.hidden = !button.dataset.productUrl;
    }

    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.modalVideo.play().catch(() => {});
    this.querySelector('[data-gallery-close-button]')?.focus();
  }

  close() {
    if (!this.modal) return;
    this.modalVideo?.pause();
    this.modal.hidden = true;
    document.body.style.overflow = '';
    this.lastTrigger?.focus();
  }
}

if (!customElements.get('liora-lens-gallery')) {
  customElements.define('liora-lens-gallery', LioraLensGallery);
}
